import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleInfo, faChartLine, faArrowTrendUp, faChevronDown, faChevronRight, faRobot } from '@fortawesome/free-solid-svg-icons';

// Register icons used across ratio tables (info, chart, trend) and statement disclosure
library.add(faCircleInfo, faChartLine, faArrowTrendUp, faChevronDown, faChevronRight, faRobot);
